import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { FieldMessageWrapper } from './field-message-wrapper';
import './field-message.scss';

type Props = ComponentPropsWithRef<'p'> & {
    state?: 'success' | 'error';
};

const FieldMessageRoot = ({ state, className, children, ...props }: Props) => (
    <p
        className={cn(
            'field-message',
            state === 'success' && 'field-message--valid',
            state === 'error' && 'field-message--invalid',
            className,
        )}
        {...props}
    >
        {children}
    </p>
);

export const FieldMessage = Object.assign(FieldMessageRoot, {
    Wrapper: FieldMessageWrapper,
});
